import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import HomeService from "../../../Services/HomeService";
import toast from "react-hot-toast";
import HttpClientXml from "../../../utils/HttpClientXml";
import moment from "moment";
import ObjectID from "bson-objectid";
import Loader from "../../../Loader/loader";
import { propertyUnits } from "../../../utils/Helper";

const WorksheetTable = forwardRef((props, ref) => {
  console.log("KJH13", props.apartmentOptions);
  const [dataAptNames, setDataAptNames] = useState(
    props.apartmentOptions || [],
  );

  const [preId, setPreId] = useState("");
  const [newDisplayOrderNumber, setNewDisplayOrderNumber] = useState(1);

  const [localities, setLocalities] = useState([]);

  const fetchLocalities = async (cityId) => {
    try {
      const res = await HomeService.getLocalities();
      console.log("HYT71", res.data, cityId);

      if (res?.data) {
        setLocalities(res.data.filter((item) => item?.city?._id === cityId));
      }
    } catch (error) {
      console.error("Error fetching localities:", error);
    }
  };

  const [data, setData] = useState(props.tableData);
  console.log("data", props.tableData);

  const initialData = {
    action: "insert",
    date: moment().format("YYYY-MM-DD"),
    remarks: "",
    status: false,
    city: props.pcity,
    propertyType: props.ptype,
    propertyFor: props.pfor,
    locality: "",
    address: "",
    locationUrl: "", // Empty string as default
    area: 0,
    floor: "",
    bhk: "",
    // ownerName: "",
    name: "",
    contactType: "", // for contact type
    phoneNo: "",
    price: "", // for new flow
    order: 0,
    newEntry: "",
    unit: "",
    priceUnit: "",
    chosen: "",
  };

  // Fix: Properly handle data initialization when props.tableData changes
  useEffect(() => {
    if (props.tableData && props.tableData.length > 0) {
      const processedData = props.tableData.map((item) => ({
        ...item,
        locationUrl: item.locationUrl || "", // Ensure locationUrl is always a string
      }));
      setData(processedData);
    } else {
      setData([]);
    }
  }, [props.tableData]);

  const handleInsertRow = (targetId, targetDisplayOrder) => {
    if (preId) {
      // return
    } else {
      setPreId(targetId);
      setNewDisplayOrderNumber(targetDisplayOrder);
    }
    const index = data.findIndex((record) => record._id === targetId);
    let updatedRecords = [...data];
    if (index !== -1) {
      updatedRecords.splice(index + 1, 0, initialData);
      console.log("OOI34", updatedRecords);
      setData(updatedRecords);
    }
  };

  const handleCancelRow = (index) => {
    setPreId(null);
    setNewDisplayOrderNumber(0);
    let updatedRecords = [...data];
    updatedRecords.splice(index, 1);
    setData(updatedRecords);
  };

  const handleDeleteData = async (id) => {
    setPreId(null);
    try {
      const res = await HomeService.deleteWorksheetProperty(id);
      if (res?.success) {
        toast.success("Row removed successfully!");
      } else {
        toast.error("Row removed successfully!");
      }
    } catch (error) {
      console.error("Error removing property:", error);
    }

    props.reload();
  };

  useImperativeHandle(ref, () => ({
    handleInsertFirst: () => {
      const index = -1;
      let updatedRecords = [...data];
      updatedRecords.splice(index + 1, 0, initialData);
      setData(updatedRecords);
      const updatedOptions = [[], ...dataAptNames];
      setDataAptNames(updatedOptions);
    },
    handleDeleteAllNewEntry: async (queryText, city, propertyType) => {
      const queryData = {
        newEntry: queryText,
        city: city,
        propertyType: propertyType,
      };
      try {
        const res = await HomeService.deleteBulkProperties(queryData);
        if (res?.success) {
          toast.success("Row(s) removed successfully!");
        } else {
          toast.error(res?.message);
        }
      } catch (error) {
        toast.error("Failed to remove property.");
        console.error("Error removing property:", error);
      }

      console.log("SER127", queryData);
      props.reload();
    },
    saveAll: async () => {
      const updatedData = data.map((property, index) => {
        const { action, ...rest } = property;
        return {
          ...rest,
          order: index + (1 + (props.pageno - 1) * props.perPage),
        };
      });

      const transformedData = updatedData.map((property) => ({
        order: property?.order,
        date: moment(property?.date).isValid()
          ? moment(property.date).format("YYYY-MM-DD")
          : moment().format("YYYY-MM-DD"),
        newEntry: property?.newEntry,
        ...(property._id && { _id: property._id }),
        propertyFor: property?.propertyFor,
        address: property?.address,
        locationUrl: property?.locationUrl || "", // Fix: Ensure locationUrl is always included
        area: property?.area,
        chosen: property?.chosen,
        bhk: property?.bhk,
        floor: property?.floor,
        // ownerName: property?.ownerName,
        name: property?.name, // changed owner name to name
        contactType: property?.contactType, // for contact type
        price: property?.price,
        phoneNo: property?.phoneNo,
        images: property?.images,
        status: property?.status === "0" ? false : property?.status,
        remarks: property?.remarks,
        age: property?.age,
        aptName: property?.aptName,
        propertyType:
          property?.propertytype?._id || property?.propertyType || props.ptype,
        city: property?.city?._id || property?.city || props.pcity,
        ...(property?.locality?._id
          ? { locality: property?.locality?._id }
          : property?.locality && { locality: property?.locality }),
        facing: property?.facing?._id || property?.facing,
        surveyorId: property?.surveyor?._id || property?.surveyorId,
        telecallerId: property?.telecaller?._id || property?.telecallerId,
        extra: property?.extra,
        ...(property.unit && { unit: property.unit }),
        ...(property.priceUnit && { priceUnit: property.priceUnit }),
      }));

      // let floorAndPriceMatch = true;
      // transformedData?.map((e, i) => {
      //   if (e?.price && e?.floor) {
      //     const floorPlusCount = e?.floor?.split("+").length - 1;
      //     const priceplusCount = e?.price?.split("+").length - 1;
      //     if (floorPlusCount !== priceplusCount) {
      //       console.log("property", e.name, e.price, e.floor);
      //       return (floorAndPriceMatch = false);
      //     }
      //   }
      // });

      // if (!floorAndPriceMatch) {
      //   return toast.error("Floor count and price count is not matching");
      // }

      const bulkData = { properties: transformedData };
      console.log(
        "WEV184 - Location URLs:",
        transformedData.map((p) => p.locationUrl),
      );
      // console.log("bulk data", bulkData);

      try {
        const res = await HomeService.addBulkProperties(bulkData);
        if (res?.status) {
          toast.success("Properties updated successfully!");
          props.reload();
        } else {
          toast.error(res?.message);
        }
      } catch (error) {
        toast.error("Failed to add property.");
        console.error("Error adding property:", error);
      }
    },
    refreshLocalities: async (cityId) => {
      try {
        const res = await HomeService.getLocalities();
        console.log("HYT71", res);

        if (res?.data) {
          setLocalities(res.data.filter((item) => item?.city?._id === cityId));
        }
      } catch (error) {
        console.error("Error fetching localities:", error);
      }
    },
  }));

  useEffect(() => {
    fetchFacings();
    fetchAllStaff();
  }, [props.pcity]);

  useEffect(() => {
    setDataAptNames(props.apartmentOptions || []);
  }, [props.apartmentOptions]);

  const handleInsertData = async (index) => {
    setPreId(null);
    const { _id, action, ...modifiedObject } = data[index];

    if (!modifiedObject.locality) return toast.error("Choose Locality");
    // if (!modifiedObject.phoneNo) return toast.error("Choose Contact Number");
    if (!modifiedObject?.propertyType)
      return toast.error("Choose Property Type");
    if (!modifiedObject?.propertyFor)
      return toast.error("Choose Available For");
    // if (!modifiedObject?.date) return toast.error("Choose Date");
    // if (!modifiedObject?.contactType) return toast.error("Choose Contact Type");
    if (!modifiedObject?.phoneNo) return toast.error("Choose Phone number");
    // if (!modifiedObject?.area) return toast.error("Choose Area");
    // if (!modifiedObject?.unit) return toast.error("Choose Unit");

    if (modifiedObject?.floor && modifiedObject?.price) {
      const floorPlusCount = modifiedObject?.floor?.split("+").length - 1;
      const priceplusCount = modifiedObject?.price?.split("+").length - 1;
      if (floorPlusCount !== priceplusCount) {
        return toast.error("Floor and Price count is not matching");
      }
    }

    let finalObject = { ...modifiedObject };

    if (!modifiedObject?.price) {
      finalObject.price = 0;
    }

    if (!modifiedObject?.area) {
      finalObject.area = 0;
    }

    // Fix: Ensure locationUrl is properly handled
    if (!modifiedObject?.locationUrl) {
      finalObject.locationUrl = "";
    }
    // checking floor count and price count
    // const floorPlusCount = modifiedObject?.floor?.split("+").length - 1;
    // const pricePlusCount = modifiedObject?.price?.split("+").length - 1;

    // if (floorPlusCount !== pricePlusCount) {
    //   toast.error("Floor count and price count is not matching");
    //   return;
    // }

    const formData = { ...finalObject, order: newDisplayOrderNumber + 1 };
    console.log(
      "Payload for add-property-byOrder - locationUrl:",
      formData.locationUrl,
    );
    try {
      const res = await HomeService.addPropertyWorksheetRow(formData);
      if (res?.status) {
        toast.success("Row inserted successfully!");
      } else {
        toast.error(res?.error);
      }
    } catch (error) {
      toast.error("Failed to add property.");
      console.error("Error adding property:", error);
    }

    props.reload();
  };

  const handleChange = async (i, e) => {
    e.preventDefault();
    let newFormValues = [...data];
    let newAptValues = [...dataAptNames];
    console.log("ASD237", e.target.name, e.target.value);

    if (e.target.name === "status") {
      if (e.target.value === "true") {
        newFormValues[i][e.target.name] = true;
      } else if (e.target.value === "false") {
        newFormValues[i][e.target.name] = false;
      }
    } else {
      // Fix: Ensure locationUrl gets proper string value
      if (e.target.name === "locationUrl") {
        newFormValues[i][e.target.name] = e.target.value || "";
      } else {
        newFormValues[i][e.target.name] = e.target.value;
      }
    }

    if (e.target.name === "locality") {
      console.log("KJH271", newFormValues[i]);

      const cityId = newFormValues[i].city._id || newFormValues[i].city;
      const localityId = newFormValues[i].locality;
      const res = await HomeService.getApartment();
      console.log("LOI337", res.data);

      const apartments = res.data.filter(
        (item) =>
          item?.city?._id === cityId && item?.locality?._id === localityId,
      );
      const newAptOptions = apartments.map((item) => ({
        _id: item._id,
        name: item.aptName,
      }));
      newAptValues[i] = newAptOptions;
      setDataAptNames(newAptValues);
    }
    setData(newFormValues);
  };

  console.log(
    "KJJ311 - Current data locationUrls:",
    data.map((item) => item.locationUrl),
  );

  // Fetch Facings
  const [facings, setFacings] = useState([]);
  const fetchFacings = async () => {
    try {
      const res = await HomeService.getFacings();
      if (res?.data) {
        setFacings(res.data);
      }
    } catch (error) {
      console.error("Error fetching facings:", error);
    }
  };

  // Fetch Staffs
  const [salesStaff, setSalesStaff] = useState([]);
  const [surveyStaff, setSurveyStaff] = useState([]);
  const [telecallingStaff, setTelecallingStaff] = useState([]);
  const [dataentryStaff, setDataentryStaff] = useState([]);

  const fetchAllStaff = async () => {
    try {
      const res = await HomeService.getStaffs();
      console.log("JYT47", res?.data);

      if (res?.data) {
        setSalesStaff(
          res?.data.filter(
            (item) => item.role === "sales" && item?.city?._id === props.pcity,
          ),
        );
        setTelecallingStaff(
          res?.data.filter(
            (item) =>
              item.role === "telecalling" && item?.city?._id === props.pcity,
          ),
        );
        setSurveyStaff(
          res?.data.filter(
            (item) => item.role === "survey" && item?.city?._id === props.pcity,
          ),
        );
        setDataentryStaff(
          res?.data.filter(
            (item) =>
              item.role === "data entry" && item?.city?._id === props.pcity,
          ),
        );
      }
    } catch (error) {
      console.error("Error fetching staffs:", error);
    }
  };

  const handleImageUpload = async (i, e) => {
    e.preventDefault();
    console.log("RRE214", i, e);

    const files = Array.from(e?.target?.files || []);
    const uploadedImages = [];

    for (let j = 0; j < files.length; j++) {
      const formData = new FormData();
      formData.append("image", files[j]);

      try {
        const res = await HttpClientXml.fileUplode(
          "image-upload",
          "POST",
          formData,
        );
        if (res?.image) {
          uploadedImages.push(res.image);
        }
      } catch (error) {
        toast.error("Failed to upload image: " + files[j].name);
        console.error("Error uploading image:", error);
      }
    }

    let newFormValues = [...data];
    const existingImages = newFormValues[i][e?.target?.name] || [];
    newFormValues[i][e?.target?.name] = [...existingImages, ...uploadedImages];
    setData(newFormValues);

    toast.success("Images uploaded successfully!");
  };

  const handleDeleteImage = (i, key) => {
    let newFormValues = [...data];
    newFormValues[i]["images"].splice(key, 1);
    setData(newFormValues);
  };

  const openLightbox = (src) => {
    document.getElementById("lightbox-img").src = src;
    document.getElementById("lightbox").classList.add("show");
  };

  const closeLightbox = () => {
    document.getElementById("lightbox").classList.remove("show");
  };

  const [isFocused, setIsFocused] = useState(false);
  const getInputWidth = (value) => {
    return isFocused ? value?.length > 5 && `${value?.length + 1}ch` : "5ch";
  };

  const swapOrder = async (data) => {
    if (!data.propertyFor) return toast.error("Choose Property for");
    console.log("YTR392", data);
    try {
      const res = await HomeService.swapProperty(data);
      if (res?.status) {
        toast.success("Swaped successfully!");
        props.reload();
      } else {
        toast.error("Error occured!");
      }
    } catch (error) {
      console.error("Error swaping property:", error);
    }
  };

  return (
    <>
      <div className="bottom-btn-container">
        <table className="worksheet_table_wrapper" style={{ height: "45vh" }}>
          <thead
            style={{ position: "sticky", top: 0, zIndex: 10, height: "45px" }}
          >
            <tr>
              <th className="work_head1">Action</th>
              <th className="work_head3">Status</th>
              <th className="work_head6">Locality</th>
              <th className="work_head6">Apartment/Building</th>
              <th className="work_head7">Address</th>
              <th className="work_head8">New($)</th>
              <th className="work_head2">Available For</th>
              <th className="work_head9">Area</th>
              <th className="work_head9">Unit</th>
              <th className="work_head10">Floors</th>
              <th className="work_head11">BHK</th>
              <th className="work_head12">Contact Type</th>
              <th className="work_head12">Contact Name</th>
              <th className="work_head13">Contact</th>
              <th className="work_head15">Pricing</th>
              <th className="work_head9">Unit</th>
              <th className="work_head9">Is Basic Property</th>
              <th className="work_head14">Extra</th>
              <th className="work_head7">Facing</th>
              <th className="work_head7">Age</th>
              <th className="work_head6">Location URL</th>
              <th
                className="work_head1"
                style={{
                  width: "200px",
                  minWidth: "200px",
                }}
              >
                Photo(s)/Video(s)
              </th>
              <th className="work_head2">Feedback</th>
              <th className="work_head1">Date</th>
              <th className="work_head1">Telecaller</th>
              <th className="work_head1">Surveyor</th>
              <th className="work_head4">City</th>
              <th className="work_head5">Property Type</th>
            </tr>
          </thead>

          <tbody>
            {props.loading && (
              <>
                <Loader message="Loading properties" />
              </>
            )}
            {data.length > 0 ? (
              data.map((e, i) => (
                <tr key={i} className={e.action ? "newRow" : ""}>
                  {e.action ? (
                    <td>
                      <div className="work_action">
                        <button
                          style={{
                            padding: "5px 10px",
                            border: "none",
                            background: "#85da4f",
                            color: "#fff",
                            borderRadius: "5px",
                            cursor: "pointer",
                            fontSize: "12px",
                            fontWeight: "600",
                          }}
                          onClick={() => handleInsertData(i)}
                        >
                          Insert
                        </button>
                        <button
                          onClick={() => handleCancelRow(i)}
                          className="work_action_delete_btn"
                        >
                          <i className="fa-solid fa-xmark"></i>
                        </button>
                      </div>
                    </td>
                  ) : (
                    <td>
                      <div className="work_action">
                        <button
                          onClick={() => handleInsertRow(e._id, e?.order || 0)}
                          className="work_action_edit_btn"
                        >
                          <i className="fa-solid fa-plus"></i>
                        </button>
                        <button
                          onClick={() => handleDeleteData(e._id)}
                          className="work_action_delete_btn"
                        >
                          <i className="fa-solid fa-trash"></i>
                        </button>
                      </div>
                    </td>
                  )}
                  <td>
                    <select
                      name="status"
                      value={e.status}
                      onChange={(e) => handleChange(i, e)}
                    >
                      <option value={false}>{0}</option>
                      <option value={true}>{1}</option>
                    </select>
                  </td>
                  <td>
                    <select
                      required
                      name="locality"
                      value={e?.locality?._id || e?.locality || ""}
                      onChange={(e) => handleChange(i, e)}
                    >
                      <option value="">Choose...</option>
                      {props.localityList.map((item, key) => (
                        <option key={key} value={item?._id}>
                          {item?.name}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td>
                    <select
                      name="aptName"
                      value={e?.aptName || ""}
                      onChange={(e) => handleChange(i, e)}
                    >
                      <option value="">Choose...</option>
                      {dataAptNames[i]?.map((item, key) => (
                        <option key={key} value={item?.name}>
                          {item?.name}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td>
                    <input
                      name="address"
                      value={e?.address || ""}
                      onChange={(e) => handleChange(i, e)}
                      onFocus={() => setIsFocused(true)}
                      onBlur={() => setIsFocused(false)}
                      style={{
                        width: getInputWidth(e?.address),
                        transition: "width 0.2s ease",
                      }}
                    />
                  </td>
                  <td>
                    <input
                      name="newEntry"
                      value={e?.newEntry || ""}
                      onChange={(e) => handleChange(i, e)}
                    />
                  </td>
                  <td>
                    <select
                      name="propertyFor"
                      value={e.propertyFor || props.pfor}
                      onChange={(e) => handleChange(i, e)}
                    >
                      <option value="">Choose...</option>
                      <option value="sale">Sale</option>
                      <option value="rent">Rent</option>
                    </select>
                  </td>
                  <td>
                    <input
                      name="area"
                      value={e?.area || ""}
                      onChange={(e) => handleChange(i, e)}
                      onFocus={() => setIsFocused(true)}
                      onBlur={() => setIsFocused(false)}
                      style={{
                        width: getInputWidth(e?.area),
                        transition: "width 0.2s ease",
                      }}
                    />
                  </td>
                  <td>
                    <select
                      name="unit"
                      value={e.unit}
                      onChange={(e) => handleChange(i, e)}
                    >
                      <option value="">Choose...</option>
                      {propertyUnits()?.areaUnits.map((item, key) => {
                        return (
                          <option key={key} value={item?.value}>
                            {item?.name}
                          </option>
                        );
                      })}
                    </select>
                  </td>
                  <td>
                    <select
                      name="floor"
                      value={e.floor || ""}
                      onChange={(e) => handleChange(i, e)}
                    >
                      <option value="">Choose...</option>
                      {propertyUnits()?.floors.map((item, key) => {
                        return (
                          <option key={key} value={item}>
                            {item}
                          </option>
                        );
                      })}
                    </select>
                  </td>
                  <td>
                    <select
                      name="bhk"
                      value={e.bhk || ""}
                      onChange={(e) => handleChange(i, e)}
                    >
                      <option value="">Choose...</option>
                      {propertyUnits()?.bhkTypes.map((item, key) => {
                        return (
                          <option key={key} value={item}>
                            {item}
                          </option>
                        );
                      })}
                    </select>
                  </td>
                  <td>
                    <select
                      value={e?.contactType}
                      name="contactType"
                      onChange={(e) => handleChange(i, e)}
                    >
                      <option value="">--select contact type--</option>
                      <option value="Dealer">Dealer</option>
                      <option value="Owner">Owner</option>
                      <option value="Builder">Builder</option>
                    </select>
                  </td>
                  <td>
                    <input
                      name="name"
                      value={e?.name || ""}
                      onChange={(e) => handleChange(i, e)}
                      onFocus={() => setIsFocused(true)}
                      onBlur={() => setIsFocused(false)}
                      style={{
                        width: getInputWidth(e?.ownerName),
                        transition: "width 0.2s ease",
                        padding: "0 5px",
                      }}
                    />
                  </td>
                  <td>
                    <input
                      required
                      name="phoneNo"
                      value={e?.phoneNo || ""}
                      onChange={(e) => handleChange(i, e)}
                      onFocus={() => setIsFocused(true)}
                      onBlur={() => setIsFocused(false)}
                      style={{
                        width: getInputWidth(e?.phoneNo),
                        transition: "width 0.2s ease",
                      }}
                    />
                  </td>
                  <td>
                    <input
                      name="price"
                      value={e?.price || ""}
                      onChange={(e) => handleChange(i, e)}
                      onFocus={() => setIsFocused(true)}
                      onBlur={() => setIsFocused(false)}
                      style={{
                        width: getInputWidth(e?.price),
                        transition: "width 0.2s ease",
                      }}
                    />
                  </td>
                  <td>
                    <select
                      name="priceUnit"
                      value={e.priceUnit}
                      onChange={(e) => handleChange(i, e)}
                    >
                      <option value="">Choose...</option>
                      {propertyUnits()?.priceUnits.map((item, key) => {
                        return (
                          <option key={key} value={item?.value}>
                            {item?.name}
                          </option>
                        );
                      })}
                    </select>
                  </td>
                  <td>
                    <select
                      name="chosen"
                      value={e.chosen}
                      onChange={(e) => handleChange(i, e)}
                    >
                      <option value="">--Select--</option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </select>
                  </td>
                  <td>
                    <input
                      name="extra"
                      value={e?.extra || ""}
                      onChange={(e) => handleChange(i, e)}
                      onFocus={() => setIsFocused(true)}
                      onBlur={() => setIsFocused(false)}
                      style={{
                        width: getInputWidth(e?.extra),
                        transition: "width 0.2s ease",
                      }}
                    />
                  </td>
                  <td>
                    <select
                      name="facing"
                      value={e.facing?._id}
                      onChange={(e) => handleChange(i, e)}
                    >
                      <option value="">Choose...</option>
                      {facings.map((item, key) => (
                        <option key={key} value={item._id}>
                          {item.facing}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td>
                    <input
                      name="age"
                      value={e?.age || ""}
                      onChange={(e) => handleChange(i, e)}
                      onFocus={() => setIsFocused(true)}
                      onBlur={() => setIsFocused(false)}
                      style={{
                        width: getInputWidth(e?.age),
                        transition: "width 0.2s ease",
                      }}
                    />
                  </td>
                  <td>
                    <input
                      name="locationUrl"
                      value={e?.locationUrl || ""}
                      style={{ width: "300px" }}
                      onChange={(e) => handleChange(i, e)}
                      onFocus={() => setIsFocused(true)}
                      onBlur={() => setIsFocused(false)}
                      placeholder="Enter location URL"
                    />
                  </td>
                  <td style={{ padding: "10px 0" }}>
                    {e.images?.length > 0 && (
                      <>
                        <div
                          style={{
                            display: "flex",
                            columnGap: "2px",
                            rowGap: "5px",
                            padding: "1px",
                            flexWrap: "wrap",
                            marginBottom: "5px",
                          }}
                        >
                          {e.images.map((img, key) => {
                            return (
                              <>
                                {img.match(/\.(jpeg|jpg|png|gif)$/i) ? (
                                  <img
                                    src={img}
                                    alt={`media-${key}`}
                                    width="50"
                                    onClick={() => openLightbox(img)}
                                  />
                                ) : (
                                  <video width="50" height="100px" controls>
                                    <source src={img} type="video/mp4" />
                                  </video>
                                )}
                                <i
                                  className="fa fa-times"
                                  style={{
                                    color: "#ff0000",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleDeleteImage(i, key)}
                                ></i>
                              </>
                            );
                          })}
                        </div>
                      </>
                    )}

                    <input
                      type="file"
                      name="images"
                      onChange={(e) => handleImageUpload(i, e)}
                      multiple
                      accept="image/*,video/*,.mkv"
                      value=""
                    />
                  </td>
                  <td>
                    <input
                      name="remarks"
                      value={e?.remarks || ""}
                      onChange={(e) => handleChange(i, e)}
                      onFocus={() => setIsFocused(true)}
                      onBlur={() => setIsFocused(false)}
                      style={{
                        width: getInputWidth(e?.remarks),
                        transition: "width 0.2s ease",
                      }}
                    />
                  </td>
                  <td>
                    <input
                      type="date"
                      name="date"
                      value={
                        e?.date && new Date(e?.date).toISOString().split("T")[0]
                      }
                      onChange={(e) => handleChange(i, e)}
                    />
                  </td>
                  <td>
                    <select
                      name="telecallerId"
                      value={e.telecallerId || e?.telecaller?._id}
                      onChange={(e) => handleChange(i, e)}
                    >
                      <option value="">Choose...</option>
                      {telecallingStaff.map((item, key) => (
                        <option key={key} value={item._id}>
                          {`${item?.name} (${item?.designation?.name})`}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td>
                    <select
                      name="surveyorId"
                      value={e.surveyorId || e?.surveyor?._id}
                      onChange={(e) => handleChange(i, e)}
                    >
                      <option value="">Choose...</option>
                      {surveyStaff.map((item, key) => (
                        <option key={key} value={item._id}>
                          {`${item?.name} (${item?.designation?.name})`}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td>{props.cityName(e?.city?._id || props.pcity)}</td>
                  <td>
                    {props.propertyTypeName(
                      e?.propertytype?._id || props.ptype,
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <>
                <tr>
                  <td
                    colSpan={28}
                    style={{
                      textAlign: "center",
                      fontWeight: "normal",
                      color: "#ff0000",
                    }}
                  >
                    {props.pcity && props.ptype
                      ? props.loading
                        ? "Loading data..."
                        : "No records found!"
                      : "Choose City and Property Type"}
                  </td>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </div>

      <div id="lightbox" className="lightbox" onClick={() => closeLightbox()}>
        <img id="lightbox-img" src="" alt="Full Size" />
      </div>
    </>
  );
});

export default WorksheetTable;

// ----------------------------------------------------------------------------------------------------------------------------------
